import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-kids-mode',
  imports: [PagePlaceholderComponent],
  templateUrl: './kids-mode.component.html',
  styleUrl: './kids-mode.component.scss'
})
export class KidsModeComponent {
  protected readonly icon = '🧒';
  protected readonly pageTitle = 'pages.kids_mode.title';
  protected readonly subtitle = 'pages.kids_mode.subtitle';
}
